import cloneDeep from 'lodash.clonedeep';

const addFieldRecursively = (data, children, field, newValueFn) => {
  const copy = cloneDeep(data);
  const recursionBaseFn = (level, name) => {
    for (const item of level) {
      item[field] = newValueFn(item, name);
      if (item[children]) {
        recursionBaseFn(item[children], item[field]);
      }
    }
  };
  recursionBaseFn(copy, '');
  return copy;
};

export { addFieldRecursively };
